import type { FaireProductEntity } from "../../entity_types/product";

export const p_tkz3vdzh5z: FaireProductEntity = {
  token: "p_tkz3vdzh5z",
  type: "product",
  name: "Laurel Luxury Candle | Gardenia, Petrichor & Garden Sage",
  brandToken: "b_rp9e5zdxjc",
  brandName: "Wilkin & May",
  imageUrl:
    "https://cdn.faire.com/fastly/19e52d8e3080425c5bced458742eca56314ce6c067c61b096ee9961b58d4f7b0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/879cb27054a108d8fcb78c5cc7f79abc53405c80d90bc86fdc97953e6c54648b.png",
    "https://cdn.faire.com/fastly/87859b9c74d5e9acfb4ebafdb8063591042f28192cb9fb14a56018aad1771ac4.jpeg",
    "https://cdn.faire.com/fastly/90cbb24abdffa0e425307d521dd2cf77f860ad3a928271aad775cf264f809c1f.jpeg",
  ],
  priceDollars: 24,
  description:
    "The garden before anyone arrives. Dew on sage. Gardenia just beginning to open. The earth still holding last night's rain.\n\nLaurel opens with the quiet brightness of gardenia and juniper before settling into sage, sandalwood, and lavender. Beneath it all, petrichor lingers like rain still resting on the earth—green, grounding, and alive.\n\nHand-poured in Ojai, California, Laurel is crafted using our clean coconut-apricot wax blend for a slow, even burn. The reusable glass vessel is designed to remain long after the candle is gone, while the warm wax itself is skin-safe and can be used as a nourishing balm.\n\nDetails:\n\n- Hand-poured in Ojai, California in small batches\n- Clean-burning coconut wax blend\n- Skin-safe wax doubles as a nourishing balm\n- 40+ hour burn time\n- Lead-free cotton wick\n- Reusable glass vessel\n- Phthalate-free, paraben-free and cruelty-free\n- Sustainable, biodegradable wax and packaging\n- Fragrance oils infused with natural botanicals\n- Ideal for garden shops, florists, plant stores, botanical displays, gift boutiques, home goods stores and home fragrance retailers\n\nLuxury positioning: fresh, green, botanical, earthy and gift-worthy.",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:55.954Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
